export default __webpack_public_path__ + "static/media/icon-promo.4464fd98.svg";